<template>
  <button
    class="tla-btn tla-btn--primary tla-btn--block"
    v-bind:class="{ 'tla-btn--spaced-bottom': isLast }"
    name="scroll-to-button"
    id="scroll-to-button"
    @click="scrollToForm()">
    {{buttonText}}
  </button>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import { scrollService } from '../../services/ScrollService';

@Component
export default class ScrollToComponent extends Vue {
  @Prop({ default: 'Keep Me Informed' })
  public buttonText!: string;

  @Prop({ default: 'personal-details' })
  public elementId!: string;

  @Prop({ default: true })
  public isLast!: boolean;

  public scrollToForm(): void {
    scrollService.scrollToElementId(this.elementId);
  }
}
</script>
